import { render, staticRenderFns } from "./CustomersAccessList.component.pug?vue&type=template&id=f47d3d76&scoped=true&lang=pug&"
import script from "./CustomersAccessList.component.ts?vue&type=script&lang=ts&"
export * from "./CustomersAccessList.component.ts?vue&type=script&lang=ts&"
import style0 from "./CustomersAccessList.component.scss?vue&type=style&index=0&id=f47d3d76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f47d3d76",
  null
  
)

export default component.exports